import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_6 = {
  class: "modal",
  style: {"width":"1020px"}
}
const _hoisted_7 = { class: "modal__content pa-1" }
const _hoisted_8 = { class: "stepper--bar" }
const _hoisted_9 = { class: "stepper--bar__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Enrich Lead", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "2", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Submit", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "stepper--bar__content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "pa--y-1 pa--left-1" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "stepper--bar__content--label__info" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createTextVNode(" Data To Be Enriched "),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__content--label__info--message__data" })
], -1)
const _hoisted_21 = { class: "row stepper--bar__content--label__info--message justify--flex-start pa-1" }
const _hoisted_22 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_23 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_24 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_25 = {
  key: 0,
  class: "stepper--bar__content--label__info--message__data"
}
const _hoisted_26 = {
  key: 1,
  class: "stepper--bar__content--label__info--message__data"
}
const _hoisted_27 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_28 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_29 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_30 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_31 = {
  key: 0,
  class: "stepper--bar__content--label__info--error pa-1"
}
const _hoisted_32 = { class: "modal__footer" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 1,
                })
              }, _hoisted_12, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 2,
                })
              }, _hoisted_15, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 1,
              }])
            }, _hoisted_18, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-2", {
                'label--active': _ctx.stepper == 2,
              }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFields, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-3 pa--bottom-1 stepper--bar__content--label__info--message__fields"
                    }, _toDisplayString(index + 1) + ". " + _toDisplayString(item.displayName), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createTextVNode(" Included Data (base cost per lead) "),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$filters.numberDisplay(1)) + " Credit ", 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createTextVNode(" Premium Data "),
                  (_ctx.selectedFields.length != 6)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$filters.numberDisplay(Math.max(_ctx.selectedFields.length-7,0))) + " Credits ", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$filters.numberDisplay(Math.max(_ctx.selectedFields.length-5,0))) + " Credit ", 1))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createTextVNode(" Leads Selected "),
                  _createElementVNode("span", _hoisted_28, " x " + _toDisplayString(_ctx.$filters.numberDisplay(_ctx.selectedLeads.length)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createTextVNode(" Total Credits "),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.response)) + " Credits ", 1)
                ]),
                (_ctx.insufficentCredits)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createTextVNode(" You don't have enough credits, "),
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.buyCredits && _ctx.buyCredits(...args)))
                      }, " Buy Credits ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        (_ctx.stepper == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, " Cancel "))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToFields && _ctx.backToFields(...args)))
            }, " Back ")),
        (_ctx.stepper == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args))),
              disabled: !_ctx.subscriptionMode && !_ctx.fields.some((f) => !f.disabled)
            }, " Proceed ", 8, _hoisted_33))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.purchaseLeads && _ctx.purchaseLeads(...args)))
            }, " Purchase "))
      ])
    ])
  ]))
}